import { Component } from "@angular/core";

@Component({
  selector: "page-contato",
  templateUrl: "contato.html",
})
export class ContatoPage {}
